import store from '@/store'

export default {
  inserted (el, binding, vnode) {
    const { value } = binding
    const roles = store.getters.getRoles
    if (value && value instanceof Array && value.length > 0) {
      if (roles && roles.length > 0) {
        const permissionRoles = value
        const hasPermission = roles.some(role => {
          return permissionRoles.includes(role.toLowerCase())
        })
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
